declare global {
  interface Window {
    __CONFIG__?: {
      apiBaseUrl?: string;
      googleClientId?: string;
      vapidPublicKey?: string;
      // 378 (#1266, trial): LiveAgent's account and chat button. Absent: no chat widget.
      liveAgentUrl?: string;
      liveAgentButtonId?: string;
      // 403 (#1317): which support chat runs (freshchat | liveagent | empty) and Freshchat's account loader.
      chatProvider?: string;
      freshchatScriptUrl?: string;
    };
  }
}

import { chatProviderFrom } from './support/chatProvider.js';
import { liveAgentConfig } from './support/liveAgent.js';

const cfg = window.__CONFIG__ ?? {};

export const API_BASE_URL = cfg.apiBaseUrl ?? '';
export const GOOGLE_CLIENT_ID = cfg.googleClientId ?? '';
export const VAPID_PUBLIC_KEY = cfg.vapidPublicKey ?? '';
/** 378: the LiveAgent account and button, or null (not configured: the widget never loads). */
export const LIVEAGENT = liveAgentConfig(cfg);
/** 403: the support chat that runs here, or null (WhatsApp stays the contact). */
export const CHAT = chatProviderFrom(cfg);
